import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FooterLuckmeComponent } from "./footer-luckme.component";

@NgModule ({

    declarations: [
        FooterLuckmeComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        FooterLuckmeComponent
    ]

})

export class FooterLuckMeModule { };